/* eslint-disable import/no-cycle */
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import ConfigYAML from '../config/ConfigYAML';
import WorkflowModal from './structures-product/WorkflowModal/WorkflowModal';

// TODO tomar este componente como base para la abstracción...contiene
// setWorkflow y pasa props a workflowmodal que otros componentes similares no pasan
const RunRebalancingReconstitution = forwardRef((props, ref) => {
  const [initialWorkFlow, setInitialWorkflow] = useState(null);
  const [modalOpened, setModalOpened] = useState(false);
  const setWorkflow = slides => {
    setInitialWorkflow(slides);
  };

  // no es la manera más ortodoxa de hacer esto, pero si la que requería menos cambios del código original
  useImperativeHandle(ref, () => ({
    runModal: () => {
      const structuredProducts = ConfigYAML.jsonPath('$.rebalancing_reconstitution');
      const sections = Object.values(structuredProducts.sections).map(s => {
        const section = { ...s };
        if (section.widgets) {
          section.widgets = Object.values(section.widgets);
        } else if (section.components) {
          section.components = Object.values(section.components);
        }
        return section;
      });
      setModalOpened(true);
      setWorkflow(sections.find(({ type }) => type === 'Slides'));
    },
  }));

  return (
    <>
      {initialWorkFlow && modalOpened && (
        <WorkflowModal
          {...initialWorkFlow}
          isModalOpen={modalOpened}
          setModalState={setModalOpened}
          setComponent={setWorkflow}
          runBacktestUbication={props.ubication}
          backtestShowData={!!props.showData}
          disable_title={props.disable_title}
        />
      )}
    </>
  );
});

export default RunRebalancingReconstitution;
